var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcpSecurityCommandCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.62 13.7C28.4252 14.168 30.0724 15.1102 31.3911 16.4289C32.7098 17.7476 33.6519 19.3948 34.12 21.2H41.18V10.48L26.62 4V13.7Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.86 21.22C14.3261 19.4139 15.2676 17.7656 16.5866 16.4466C17.9056 15.1276 19.5539 14.1861 21.36 13.72V4L6.82001 10.48V21.22H13.86Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.38 34C19.5748 33.532 17.9276 32.5898 16.6089 31.2711C15.2902 29.9525 14.3481 28.3052 13.88 26.5H7.26001C8.00554 30.3483 9.68229 33.9553 12.1437 37.006C14.6051 40.0566 17.7763 42.4579 21.38 44V34Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.14 26.5C33.672 28.3052 32.7298 29.9525 31.4111 31.2711C30.0925 32.5898 28.4452 33.532 26.64 34V44C30.24 42.4553 33.4071 40.0528 35.8649 37.0024C38.3227 33.9519 39.9965 30.3462 40.74 26.5H34.14Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.1C26.905 29.1 29.26 26.745 29.26 23.84C29.26 20.935 26.905 18.58 24 18.58C21.095 18.58 18.74 20.935 18.74 23.84C18.74 26.745 21.095 29.1 24 29.1Z",
    fill: "#669DF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpSecurityCommandCenter);
export default __webpack_public_path__ + "static/media/GCP_security_command_center.7015bd88c6fbabbf538d8d3a67eda299.svg";
export { ForwardRef as ReactComponent };